import { BRAND } from "../brand";

export const email = {
  footer: `Bu e-posta ${BRAND.name} tarafından {company} adına gönderildi. Bildirim tercihlerinizi uygulamadaki Profil > Bildirimler bölümünden değiştirebilirsiniz.`,
  /** Hesap e-postaları (parola sıfırlama): bir şirket adına gönderilmez, bildirim tercihi de yoktur. */
  footer_account: `Bu e-posta ${BRAND.name} tarafından gönderildi.`,
  open: "Uygulamada aç",
  invitation: {
    subject: `{company} sizi ${BRAND.tr.dat} davet etti`,
    heading: "Merhaba {name},",
    body: `{company} izin, belge ve bordro işlemlerinizi ${BRAND.name} üzerinden yürütüyor. Hesabınızı oluşturmak için aşağıdaki bağlantıyı kullanın. Bağlantı {days} gün geçerlidir.`,
    cta: "Hesabımı oluştur",
  },
  password_reset: {
    subject: "Parola sıfırlama bağlantınız",
    heading: "Merhaba,",
    body: `${BRAND.name} hesabınız için parola sıfırlama istendi. Bu isteği siz yapmadıysanız bu e-postayı yok sayabilirsiniz. Bağlantı 1 saat geçerlidir.`,
    cta: "Yeni parola belirle",
  },
};
